import { Button, Input, Flex, Typography, Alert } from 'antd';
import { QRCodeSVG } from 'qrcode.react';
import styles from './ScanStep.module.css';

const { Text, Title } = Typography;

interface ScanStepProps {
  provisioningUri: string;
  secret: string;
  confirmCode: string;
  onCodeChange: (code: string) => void;
  onConfirm: () => void;
  onCancel?: () => void;
  isLoading: boolean;
}

export const ScanStep = ({
  provisioningUri,
  secret,
  confirmCode,
  onCodeChange,
  onConfirm,
  onCancel,
  isLoading,
}: ScanStepProps) => (
  <Flex vertical gap={16} align="center" className={styles.scanStep}>
    <Title level={5}>Scan QR Code</Title>
    <Text type="secondary" className={styles.instruction}>
      Scan this QR code with your authenticator app, then enter the 6-digit code
      below to confirm.
    </Text>

    <div className={styles.qrContainer}>
      <QRCodeSVG value={provisioningUri} size={200} level="M" />
    </div>

    <Alert
      type="info"
      title="Can't scan the QR code?"
      description={
        <Text copyable={{ text: secret }} className={styles.secretText}>
          Manual entry key: <code>{secret}</code>
        </Text>
      }
      className={styles.manualEntry}
    />

    <Flex vertical gap={8} className={styles.confirmInput}>
      <Text strong>Verification code</Text>
      <Input
        placeholder="Enter 6-digit code"
        value={confirmCode}
        onChange={(e) => {
          const val = e.target.value.replace(/\D/g, '').slice(0, 6);
          onCodeChange(val);
        }}
        maxLength={6}
        onPressEnter={onConfirm}
      />
    </Flex>

    <Flex gap={8} className={styles.buttonGroup}>
      <Button
        type="primary"
        onClick={onConfirm}
        loading={isLoading}
        disabled={confirmCode.length < 6}
        className={styles.actionButton}
      >
        Confirm
      </Button>
      {onCancel && (
        <Button onClick={onCancel} className={styles.actionButton}>
          Cancel
        </Button>
      )}
    </Flex>
  </Flex>
);
